import React from 'react';
import { Star } from 'lucide-react';
interface RatingProps {
  value: number;
  max?: number;
  size?: number;
  showValue?: boolean;
  interactive?: boolean;
  onChange?: (value: number) => void;
}
export function Rating({
  value,
  max = 5,
  size = 16,
  showValue = false,
  interactive = false,
  onChange
}: RatingProps) {
  const handleClick = (index: number) => {
    if (interactive && onChange) {
      onChange(index + 1);
    }
  };
  return <div className="flex items-center gap-1" data-id="element-440">
      {Array.from({
      length: max
    }).map((_, index) => {
      const isFilled = index < Math.floor(value);
      const isHalf = index < value && index >= Math.floor(value);
      return <button key={index} onClick={() => handleClick(index)} disabled={!interactive} className={interactive ? 'cursor-pointer' : 'cursor-default'} type="button" data-id="element-441">
            <Star size={size} className={`${isFilled ? 'fill-clay text-clay' : isHalf ? 'fill-clay/50 text-clay' : 'fill-none text-moss-gray'} transition-colors`} strokeWidth={1.5} data-id="element-442" />
          </button>;
    })}
      {showValue && <span className="text-sm font-medium text-charcoal ml-1" data-id="element-443">
          {value.toFixed(1)}
        </span>}
    </div>;
}